/* tslint:disable */
/* eslint-disable */
export enum AdminSetting {
  AdminRead = 'admin_read',
  AdminWrite = 'admin_write',
}
